import script from "./SyllableTrackerDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SyllableTrackerDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./SyllableTrackerDetailModal.vue?vue&type=style&index=0&id=6a5fbc59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5fbc59"]])

export default __exports__